import LockIcon from '@mui/icons-material/Lock';
import SearchIcon from '@mui/icons-material/Search';
import {
    Button,
    Chip,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Box as MuiBox,
    Select,
    Tooltip
} from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// With these individual imports
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import ReplayIcon from '@mui/icons-material/Replay';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import Sub from '../libs/Sub';
//import languages from '../libs/languages';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import ModernBreadcrumbs from '../components/navigation/ModernBreadcrumbs';
import { fetchBlobUrl } from '../components/subtitles/ReadBlobToString';
import { getLanguagesForEditView } from '../components/subtitles/SelectLanguageComponent';
import { useLogging } from '../folders/LoggingProvider';
import { useAutoSave } from '../hooks/useAutoSave';
import { file2vtt, getSubNodesfromVtt, sub2srt, sub2txt, sub2vtt } from '../libs/readSub/SubUtils';
import sectionManagementService from '../services/SectionManagementService';
import videoCRUDServiceInstance from '../services/VideoCRUDService';
import { download, getExt } from '../utils';
// axios and direct auth header usage removed from this file; maintenance admin UI moved to SystemStatusPage
// Add this with other imports
import BugReportIcon from '@mui/icons-material/BugReport';
import DescriptionIcon from '@mui/icons-material/Description';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { formatUserName } from '../utils/formatUtils';
import { readSubtitleFromStorage, writeSubtitleToStorage } from '../utils/subtitleStorage';
import { processTranscript } from '../utils/transcriptSegmentation';

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    width: 100%; // Make sure Style takes full width
    max-width: 100%; // Prevent overflow

    .tool {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 3px 3px;
        max-width: 100%;
        width: 100%;
        flex: 1;
    }

    .top {
        display: flex; // Fix this property - was display: flex-direction
        flex-direction: column; // Changed from row to column
        width: 100%; // Ensure it takes full width
        flex: 1; // Add flex: 1 to fill container
    }

    /* First operate div for the logo and breadcrumbs */
    .operate:first-child {
        display: flex;

        .breadcrumb {
            flex: 1;
            width: 100%;
        }
    }

    /* Second operate div for the toolbar controls */
    .operate:nth-child(2) {
        display: flex;
        flex-direction: row;
        justify-content: flex-end; // Ensure everything aligns to the right
        align-items: center;
        flex-wrap: nowrap;
        overflow-x: auto;

        .breadcrumb {
            display: none;
        }

        button,
        .MuiFormControl-root {
            flex-shrink: 0;
        }

        .left-buttons {
            display: none;
        }

        .right-buttons {
            display: flex;
            align-items: center;
            justify-content: flex-end; // This is correct
            margin-left: auto; // Change from 40% to auto to push to the right
            padding-right: 10px; // Add some padding on the right
            gap: 8px; // Use gap instead of individual margins for consistent spacing
            flex-wrap: nowrap; // Prevent wrapping
            overflow-x: auto; // Allow horizontal scrolling if needed
        }

        /* Adjust button margins in right-buttons */
        .right-buttons .MuiButton-root,
        .right-buttons .MuiFormControl-root {
            margin-left: 0 !important; // Remove individual left margins
        }
    }
    /* Search box styling */
    .searchboxs {
        background: rgba(30, 30, 30, 0.95);
        border-radius: 0 0 6px 6px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        position: fixed;
        top: -100px; /* Start off-screen */
        left: 0;
        right: 0;
        width: 100%;
        padding: 16px 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        transition: top 0.3s ease;
        display: flex;
        align-items: center;

        &.open {
            top: 0; /* Slide in from the top */
            display: flex;
        }

        .navsearch {
            background: rgba(51, 51, 51, 0.7);
            border: none;
            border-right: 1px solid rgba(68, 68, 68, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 0 3px;
            color: #ccc;
            transition: color 0.2s ease;

            &:hover {
                color: #fff;
            }

            &.open svg {
                transform: rotate(90deg);
                transition: transform 0.2s ease;
            }
        }

        .searchboxlist {
            padding: 1px;
            width: 100%;
            max-width: 800px;
            margin: 0 auto;

            ul {
                list-style: none;
                padding: 0;
                margin: 0 0 5px 0;
                display: flex;
                align-items: center;

                li {
                    margin-right: 5px;

                    &.search-input {
                        flex: 1;

                        input {
                            width: 100%;
                            padding: 8px 12px;
                            border: 1px solid rgba(68, 68, 68, 0.7);
                            border-radius: 4px;
                            background: rgba(51, 51, 51, 0.7);
                            color: #fff;
                            font-size: 14px;

                            &:focus {
                                outline: none;
                                border-color: rgba(0, 123, 255, 0.5);
                                box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
                            }
                        }
                    }

                    span {
                        color: #aaa;
                        font-size: 0.8rem;
                        margin: 0 8px;
                        white-space: nowrap;
                    }

                    .updown-navs {
                        background: rgba(68, 68, 68, 0.7);
                        border: 1px solid rgba(85, 85, 85, 0.5);
                        border-radius: 4px;
                        padding: 4px;
                        cursor: pointer;
                        margin: 0 2px;
                        color: #ccc;
                        transition: all 0.2s ease;

                        &:hover:not(:disabled) {
                            background: rgba(85, 85, 85, 0.7);
                            color: #fff;
                        }

                        &:disabled {
                            opacity: 0.5;
                            cursor: not-allowed;
                        }
                    }

                    .colsesearch {
                        background: rgba(68, 68, 68, 0.7);
                        border: 1px solid rgba(85, 85, 85, 0.5);
                        border-radius: 4px;
                        padding: 4px;
                        cursor: pointer;
                        color: #ccc;
                        transition: all 0.2s ease;

                        &:hover {
                            background: rgba(85, 85, 85, 0.7);
                            color: #fff;
                        }
                    }

                    .buttons {
                        display: flex;

                        button {
                            background: #007acc !important;
                            color: white !important;
                            border: none !important;
                            border-radius: 4px;
                            padding: 6px 12px;
                            margin-right: 5px;
                            cursor: pointer;
                            font-size: 13px;
                            transition: background 0.2s ease;

                            &:hover {
                                background: #0062a3 !important;
                            }
                        }
                    }
                }
            }
        }
    }

    /* Dual Column Settings Drawer - more compact like search box */
    .dualcolumnbox {
        background: rgba(30, 30, 30, 0.95);
        border-radius: 0 0 6px 6px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        position: fixed;
        top: -100px; /* Start off-screen */
        left: 0;
        right: 0;
        width: 100%;
        padding: 8px 24px; /* Further reduced padding */
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        transition: top 0.3s ease;
        display: none;

        &.open {
            top: 0; /* Slide in from the top */
            display: block;
        }

        .dualcolumnlist {
            padding: 1px;
            width: 100%;
            max-width: 1200px; /* Increased width for single line layout */
            margin: 0 auto;

            .drawer-content {
                /* Single line layout */
                .controls-row {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    flex-wrap: nowrap; /* Prevent wrapping */
                    justify-content: space-between;

                    .drawer-header {
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        gap: 15px;

                        h3 {
                            color: #fff;
                            margin: 0;
                            font-size: 0.85rem; /* Reduced font size */
                            font-weight: 500;
                            white-space: nowrap;
                        }
                    }

                    .checkbox-group {
                        flex-shrink: 0;

                        .MuiFormControlLabel-root {
                            margin: 0;

                            .MuiFormControlLabel-label {
                                font-size: 0.75rem !important; /* Smaller font */
                                white-space: nowrap;
                            }
                        }
                    }

                    .language-selectors {
                        display: flex;
                        gap: 15px;
                        flex: 1;
                        min-width: 0; /* Allow shrinking */

                        .language-group {
                            flex: 1;
                            min-width: 100px; /* Reduced min-width */

                            .language-label {
                                display: block;
                                color: rgba(255, 255, 255, 0.8);
                                font-size: 0.7rem; /* Smaller font */
                                margin-bottom: 2px; /* Reduced margin */
                                font-weight: 500;
                                white-space: nowrap;
                            }
                        }
                    }

                    .close-drawer {
                        background: rgba(68, 68, 68, 0.7);
                        border: 1px solid rgba(85, 85, 85, 0.5);
                        border-radius: 4px;
                        padding: 4px;
                        cursor: pointer;
                        color: #ccc;
                        transition: all 0.2s ease;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;

                        &:hover {
                            background: rgba(85, 85, 85, 0.7);
                            color: #fff;
                        }
                    }
                }
            }
        }
    }

    /* Add this to your Style component's CSS definition, after the existing breadcrumb class */

    .breadcrumb {
        flex: 1;
        width: 100%;

        /* Make breadcrumbs responsive */
        @media (max-width: 768px) {
            .header-container {
                flex-direction: column !important;

                /* Make logo smaller on small screens */
                .MuiAvatar-root {
                    width: 32px !important;
                    height: 32px !important;
                    margin-right: 8px !important;
                    align-self: flex-start;
                }

                /* Stack header elements vertically on small screens */
                .right-section {
                    width: 100%;

                    .top-row {
                        flex-wrap: wrap;
                        margin-bottom: 4px !important;

                        /* Hide the tagline on very small screens */
                        .header-tagline {
                            display: none;
                        }
                    }

                    /* Make breadcrumbs scrollable horizontally on small screens */
                    .breadcrumb-row {
                        .MuiBreadcrumbs-ol {
                            display: flex;
                            flex-wrap: nowrap !important;
                            overflow-x: auto;
                            padding-bottom: 4px;
                            scrollbar-width: thin;

                            &::-webkit-scrollbar {
                                height: 3px;
                            }

                            &::-webkit-scrollbar-track {
                                background: rgba(255, 255, 255, 0.05);
                            }

                            &::-webkit-scrollbar-thumb {
                                background-color: rgba(255, 255, 255, 0.2);
                                border-radius: 3px;
                            }

                            .MuiBreadcrumbs-li {
                                white-space: nowrap;
                                flex-shrink: 0;
                            }
                        }
                    }
                }
            }
        }

        /* Even more compact for very small screens */
        @media (max-width: 480px) {
            .header-container {
                .right-section {
                    .top-row {
                        /* Hide tagline completely */
                        .header-tagline {
                            display: none;
                        }

                        /* Make user email smaller */
                        .user-info {
                            font-size: 0.7rem !important;
                        }

                        /* Make language badge smaller */
                        .language-badge {
                            font-size: 0.65rem !important;
                            padding: 0 4px !important;
                        }
                    }
                }
            }
        }
    }
`;

export default function Header({
    undoSubs,
    clearSubs,
    loading,
    setLoading,
    subtitle,
    formatSub,
    setSubtitle,
    notify,
    translate,
    setTranslate,
    viewEng,
    setViewEng,
    bookmarked,
    subtitleComment,
    selectedLng,
    setSelectedLng,

    // Add these new props
    leftColumnLanguage,
    setLeftColumnLanguage,
    rightColumnLanguage,
    setRightColumnLanguage,
    showDualColumns,
    setShowDualColumns,

    // Search related props
    showSearch,
    setShowSearch,
    handleShowSearch,
    searchTerm: parentSearchTerm,
    replaceTerm: parentReplaceTerm,
    onSearchTermChange,
    onReplaceTermChange,
    matchOffsets,
    currentMatchIndex,
    goToNextMatch,
    goToPreviousMatch,
    handleReplace,
    handleReplaceAll,

    lngIndex,
    setLngIndex,
    setLanguageSubTitle,
    setBookmarked,
    setSubtitleComment,
    readOnly,
    duplicateSessionDetected,
    saveMirroredGujaratiVtt,
    player, // Add player prop
}) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [breadcrumb, setBreadcrumb] = useState([]);
    const { addLog, clearLogs } = useLogging();

    const open = Boolean(anchorEl);

    const [exportValue, setExportValue] = useState('SRT');
    const [languages, setLanguages] = useState([]);

    // Add this line to create the currentPath from breadcrumb
    const currentPath = breadcrumb && breadcrumb.length > 0 ? `/${breadcrumb.join('/')}` : '/';

    const user = JSON.parse(localStorage.getItem('authUser'));

    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [loadingSections, setLoadingSections] = useState(false);
    const [sectionError, setSectionError] = useState(null);

    // Define local state for search
    const [showReplace, setShowReplace] = useState(false);
    const [searchTerm, setSearchTerm] = useState(parentSearchTerm || '');
    const [replaceTerm, setReplaceTerm] = useState(parentReplaceTerm || '');
    const [inputText1, setInputText1] = useState('');
    const [inputText2, setInputText2] = useState('');
    const [lnagText1, setLnagText1] = useState('');
    // Add these state variables inside your Header component
    const [containerWidth, setContainerWidth] = useState(window.innerWidth);
    const headerContainerRef = useRef(null);
    // Add state for the dual column drawer
    const [showDualColumnDrawer, setShowDualColumnDrawer] = useState(false);

    const isPlayerLoaded = Boolean(player?.element && player.element.readyState >= 2);
    const isLanguageChangeBlocked = !isPlayerLoaded || Boolean(loading);
    
    // Transcript import functionality
    const transcriptFileInputRef = useRef(null);

    // Add handler for the three dots button
    const handleDualColumnMenuClick = () => {
        setShowDualColumnDrawer(!showDualColumnDrawer);
    };

    // Add this useEffect to track the header container width
    useEffect(() => {
        if (!headerContainerRef.current) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                setContainerWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(headerContainerRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    const getCurrentSubtitles = () => {
        // Always prioritize current in-memory component state.
        // NOTE: Do NOT write to storage here — this is a pure getter.
        // Writing here risks overwriting the newly-selected language's key with
        // stale subtitle data from the previous language during a language switch.
        if (subtitle && subtitle.length > 0) {
            return subtitle;
        }

        // Fallback to storage helper (legacy fallback inside helper)
        const localStorageSubtitles = readSubtitleFromStorage(selectedLng) || [];
        return localStorageSubtitles;
    };

    // Create a separate autoSave function first
    const autoSaveFunction = async (arg) => {
        // Callers may pass: an object {importedSubtitles, importSource}, no arg, or even a raw array
        const opts = arg && typeof arg === 'object' && !Array.isArray(arg) ? arg : {};
        const { importedSubtitles = null, importSource = null, isAutoSave = false } = opts;
        console.log('🚀 === SAVE FUNCTION START ===');
        console.log('📍 Save target:', {
            selectedLanguage: selectedLng,
            importSource,
            subtitleLength: importedSubtitles?.length || subtitle?.length || 0,
            timestamp: new Date().toISOString(),
        });

        // Use imported subtitles if provided, otherwise get current in-memory subtitles.
        // NOTE: We read directly from in-memory subtitle state — no storage flush needed here.
        // Storage writes happen in the editor on every edit (debounced) and on language switch.
        let currentSubtitles = importedSubtitles || getCurrentSubtitles();
        console.log('📊 Current subtitles to save:', currentSubtitles?.length || 0);

        // Don't attempt to save if no subtitles exist
        if (!currentSubtitles || currentSubtitles.length === 0) {
            console.log('❌ SAVE SKIPPED: No subtitles to save');
            return { success: false, message: 'No subtitles to save' };
        }

        if (readOnly) {
            let message = duplicateSessionDetected
                ? 'Duplicate session detected. Please refresh the page.'
                : 'Read-Only Mode. You cannot save changes.';
            console.log('🚫', message);
            addLog(message);
            return { success: false, message };
        }

        console.log('✅ PROCEEDING WITH SAVE for:', selectedLng);

        try {
            // Filter subtitles where start, end, text are not all empty
            const filteredSubtitle = currentSubtitles.filter((transcript) => {
                return (
                    transcript.start !== '00:00:00' ||
                    transcript.end !== '00:00:00' ||
                    transcript.text !== '' ||
                    transcript.text2 !== ''
                );
            });

            console.log('📝 Filtered subtitle count:', filteredSubtitle.length);

            // MAIN SAVE - Always do this first and wait for completion
            console.log('💾 Starting main save for:', selectedLng);
            const mainSaveResult = await videoCRUDServiceInstance.saveSubtitleContent(
                filteredSubtitle,
                selectedLng,
                bookmarked,
                subtitleComment,
                addLog,
                importSource ? false : !isAutoSave, // Only show feedback for manual saves, not auto-saves or imports
                importSource,
            );

            if (!mainSaveResult.success) {
                console.error('❌ Main save failed for', selectedLng, ':', mainSaveResult.message);
                return mainSaveResult;
            }

            console.log('✅ Main save completed successfully for:', selectedLng);

            // GUJARATI MIRRORING - Only do this AFTER main save succeeds AND only for English
            if (selectedLng === 'English') {
                console.log('🪞 Starting Gujarati mirroring (separate operation)...');
                try {
                    await saveMirroredGujaratiVtt('auto');
                    console.log('✅ Mirrored Gujarati save completed');
                } catch (gujaratiError) {
                    console.error('⚠️ Gujarati mirroring failed (but main save succeeded):', gujaratiError.message);
                    // Don't fail the main save if Gujarati mirroring fails
                    addLog(`Warning: Gujarati mirroring failed: ${gujaratiError.message}`);
                }
            }

            console.log('🎉 === SAVE FUNCTION COMPLETE ===');
            return { success: true };
        } catch (err) {
            console.error('💥 Error in autoSaveFunction:', {
                language: selectedLng,
                error: err.message,
                stack: err.stack,
            });
            addLog(`Failed to save subtitle: ${err.message}`);
            return { success: false, error: err, message: err.message };
        }
    };

    // Set onAutoSave to use our autoSaveFunction
    const onAutoSave = useCallback(autoSaveFunction, [
        subtitle,
        selectedSection,
        readOnly,
        duplicateSessionDetected,
        selectedLng,
        bookmarked,
        subtitleComment,
    ]);

    const { lastSaveTime, isSaving, lastError, saveNow } = useAutoSave({
        saveFunction: autoSaveFunction,
        data: subtitle,
        enabled: user?.languageAccess?.[selectedLng] === 'WRITE' || user?.languageAccess?.[selectedLng] === 'ADMIN',
        interval: 30000, // 30 seconds
        inactivityDelay: 600000, // 10 minutes
        saveOnUnmount: false,
    });

    useEffect(() => {
        const handleMaintenanceEvent = async (ev) => {
            const info = ev?.detail || ev;
            if (!info) return;
            if (info.active) {
                console.log('⚠️ Maintenance active:', info);
                try {
                    if (typeof saveNow === 'function') {
                        await saveNow();
                    }
                } catch (e) {
                    console.error('Failed to auto-save during maintenance notice', e);
                }

                const msg = info.message || 'Server maintenance scheduled. Please save and logout.';
                try {
                    if (window.Swal) {
                        window.Swal.fire({
                            title: 'Maintenance starting soon',
                            text: msg,
                            icon: 'warning',
                            confirmButtonText: 'Save & Logout',
                            showCancelButton: true,
                            cancelButtonText: 'Stay (read-only)',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                // After saving, navigate away to reduce edit conflicts
                                window.location.href = '/';
                            }
                        });
                    }
                } catch (e) {
                    // ignore UI errors
                }
            } else {
                // maintenance ended
                if (window.Swal) {
                    window.Swal.fire({ title: 'Maintenance ended', text: info.message || '', icon: 'info', timer: 2000 });
                }
            }
        };

        window.addEventListener('maintenance:update', handleMaintenanceEvent);

        return () => {
            window.removeEventListener('maintenance:update', handleMaintenanceEvent);
        };
    }, [saveNow]);

    

    const downloadSub = useCallback(
        (type) => {
            const videoProps = JSON.parse(localStorage.getItem('videoProps'));

            let text = '';
            //const name = `${videoProps?.videoUrl?.split('video/')[1].split('.mp4')[0]}.${type}`;
            let name = videoProps.videoName;
            let exportEnglish = false;
            if (selectedLng === 'English') {
                exportEnglish = true;
            }

            const storedSubs = readSubtitleFromStorage(selectedLng);
            if (storedSubs && storedSubs.length) {
                subtitle = storedSubs;
            }

            let parsedSubtitle = [];

            subtitle.forEach((subtitle, index) => {
                const cue = {
                    identifier: '',
                    start: subtitle.start,
                    end: subtitle.end,
                    text: subtitle.text2,
                    Estart: subtitle.start,
                    Eend: subtitle.end,
                    Etext: subtitle.text,
                    note: subtitle.note,
                    bookmark: subtitle.bookmark,
                };
                parsedSubtitle.push(cue);
            });

            parsedSubtitle = parsedSubtitle.filter((transcript) => {
                return !(transcript.start === '00:00:00' && transcript.end === '00:00:00');
            });

            switch (type) {
                case 'vtt':
                    text = sub2vtt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.vtt';
                    break;
                case 'srt':
                    text = sub2srt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.srt';
                    break;
                case 'txt':
                    text = sub2txt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.txt';
                    break;
                default:
                    text = sub2srt(parsedSubtitle, exportEnglish);
                    name = name + selectedLng + '.srt';
                    break;
            }
            const url = URL.createObjectURL(new Blob([text]));
            download(url, name);
        },
        [subtitle, viewEng],
    );

    const mergeSubtitleWithEnglish = async (stateUpdated, targetLanguage) => {
        // Use the explicitly passed targetLanguage when available (avoids stale closure values
        // from async callbacks where selectedLng/showDualColumns may not have updated yet).
        const effectiveLng = targetLanguage || selectedLng;
        const isDualColumn = effectiveLng !== 'English' && effectiveLng !== 'Gujarati';

        console.log(`Merging subtitle data for language: ${effectiveLng}, isDualColumn: ${isDualColumn}`);

        // For dual column languages, handle the special merging logic
        if (isDualColumn) {
            // Compute the left column language directly from videoProps so we don't rely on
            // the potentially-stale leftColumnLanguage state captured in this closure.
            const videoProps = JSON.parse(localStorage.getItem('videoProps'));
            const hasEnglishVO = videoProps?.videoLanguages?.some((l) => l.languageName === 'English-VO');
            const effectiveLeftColLang = hasEnglishVO
                ? (effectiveLng === 'English-VO' ? 'English' : 'English-VO')
                : 'English';

            console.log(`Dual column merge: ${effectiveLeftColLang} (left) + ${effectiveLng} (right)`);

            // Find the left column language index
            const leftColumnLangIndex = videoProps.videoLanguages.findIndex(
                (lang) => lang.languageName === effectiveLeftColLang,
            );

            if (leftColumnLangIndex !== -1) {
                try {
                    // Fetch the left column language VTT data
                    const leftColumnVttData = await fetchBlobUrl(
                        videoProps.videoLanguages[leftColumnLangIndex].vttFileUrl,
                    );

                    if (leftColumnVttData) {
                        // Parse the left column VTT data
                        const leftColumnSubtitles = getSubNodesfromVtt(leftColumnVttData);

                        // Iterate only up to the right column (English-VO) cue count.
                        // Using Math.max would create blank entries for every English cue
                        // beyond what English-VO has, which re-injects blank cues on every load.
                        const mergedData = [];

                        for (let index = 0; index < stateUpdated.length; index++) {
                            const leftSub = leftColumnSubtitles[index];
                            const rightSub = stateUpdated[index];

                            // If we have a left subtitle, use it as base
                            if (leftSub) {
                                mergedData.push(
                                    new Sub({
                                        // Use left subtitle structure as base but override with right column timing
                                        ...leftSub,
                                        // Use right column timing so edits to target-language timings are preserved.
                                        // Use ?? (not ||) so start=0 (first cue) is not treated as falsy.
                                        start: rightSub?.start ?? leftSub.start,
                                        end: rightSub?.end ?? leftSub.end,
                                        // Add right column text as the main editing text
                                        text: rightSub?.text || '',
                                        text2: rightSub?.text2 || '',
                                        // Keep left column (English) text and timing in E-prefixed fields for reference display
                                        Etext: leftSub.text || '',
                                        Etext2: leftSub.text2 || '',
                                        Estart: leftSub.start,
                                        Eend: leftSub.end,
                                        // Preserve any other properties, preferring right column values
                                        note: rightSub?.note || leftSub.note || '',
                                        bookmark: rightSub?.bookmark || leftSub.bookmark || false,
                                    }),
                                );
                            }
                            // If we only have a right subtitle (right has more than left)
                            else if (rightSub) {
                                mergedData.push(
                                    new Sub({
                                        // Use right subtitle as base since left doesn't exist
                                        ...rightSub,
                                        // Right column text becomes the main editing text
                                        text: rightSub.text || '',
                                        text2: rightSub.text2 || '',
                                        // No left column text or timing available
                                        Etext: '',
                                        Etext2: '',
                                        Estart: '',
                                        Eend: '',
                                        // Use right column properties
                                        note: rightSub.note || '',
                                        bookmark: rightSub.bookmark || false,
                                    }),
                                );
                            }
                        }

                        setLanguageSubTitle(mergedData);
                        console.log(
                            `Successfully merged ${effectiveLng} (${stateUpdated.length} subs) into ${effectiveLeftColLang} base (${leftColumnSubtitles.length} subs). Result: ${mergedData.length} subs`,
                        );
                    }
                } catch (error) {
                    console.error('Error in dual column merge:', error);
                    // Fallback to original logic
                    setLanguageSubTitle(stateUpdated);
                }
            }
        } else {
            // Original logic for single column languages (English, Gujarati)
            console.log('Single column language, using original merge logic');

            if (subtitle === undefined || subtitle.length === 0) {
                setLanguageSubTitle(stateUpdated);
            } else {
                const maxLength = Math.max(subtitle.length, stateUpdated.length);
                const mergeEnglishIntoNewLanguage = [];

                for (let index = 0; index < maxLength; index++) {
                    const englishSub = subtitle[index];
                    const newLangSub = stateUpdated[index];

                    // If we have a new language subtitle, use it as base
                    if (newLangSub) {
                        mergeEnglishIntoNewLanguage.push({
                            ...newLangSub,
                            Etext: englishSub?.text || '',
                            Etext2: englishSub?.text2 || '',
                            Estart: englishSub?.start || newLangSub.start,
                            Eend: englishSub?.end || newLangSub.end,
                        });
                    }
                    // If we only have an English subtitle (English has more than new language)
                    else if (englishSub) {
                        mergeEnglishIntoNewLanguage.push({
                            // Create a new subtitle entry with English data
                            start: englishSub.start,
                            end: englishSub.end,
                            text: '', // Empty text for new language
                            text2: '', // Empty text2 for new language
                            Etext: englishSub.text || '',
                            Etext2: englishSub.text2 || '',
                            Estart: englishSub.start,
                            Eend: englishSub.end,
                            note: englishSub.note || '',
                            bookmark: englishSub.bookmark || false,
                        });
                    }
                }

                setLanguageSubTitle(mergeEnglishIntoNewLanguage);
            }
        }
    };

    const onSubtitleChange = useCallback(
        (event) => {
            const file = event.target.files[0];
            if (file) {
                const ext = getExt(file.name);
                if (['ass', 'vtt', 'srt', 'json'].includes(ext)) {
                    // Show loading state immediately
                    setLoading(`Processing\n\n${file.name.split('.')[0]}\nsubtitle file...`);

                    file2vtt(file)
                        .then(async (res) => {
                            const stateUpdated = getSubNodesfromVtt(res);

                            // Process the data for saving based on current settings
                            let processedSubtitles = [...stateUpdated];

                            // If dual columns is enabled and we're not on English/Gujarati
                            if (showDualColumns && selectedLng !== 'English' && selectedLng !== 'Gujarati') {
                                console.log(`Dual column merge: ${leftColumnLanguage} (left) + ${selectedLng} (right)`);

                                const videoProps = JSON.parse(localStorage.getItem('videoProps'));
                                const leftColumnLangIndex = videoProps.videoLanguages.findIndex(
                                    (lang) => lang.languageName === leftColumnLanguage,
                                );

                                if (leftColumnLangIndex !== -1) {
                                    try {
                                        // Fetch the left column language VTT data
                                        const leftColumnVttData = await fetchBlobUrl(
                                            videoProps.videoLanguages[leftColumnLangIndex].vttFileUrl,
                                        );

                                        if (leftColumnVttData) {
                                            const leftColumnSubtitles = getSubNodesfromVtt(leftColumnVttData);
                                            // Iterate only up to the uploaded file's cue count to avoid
                                            // blank entries for English cues beyond the uploaded language.
                                            const mergedData = [];

                                            for (let index = 0; index < stateUpdated.length; index++) {
                                                const leftSub = leftColumnSubtitles[index];
                                                const rightSub = stateUpdated[index];

                                                if (leftSub) {
                                                    mergedData.push({
                                                        ...leftSub,
                                                        // Use right column timing so edits to target-language timings are preserved.
                                                        // Use ?? (not ||) so start=0 (first cue) is not treated as falsy.
                                                        start: rightSub?.start ?? leftSub.start,
                                                        end: rightSub?.end ?? leftSub.end,
                                                        text: rightSub?.text || '',
                                                        text2: rightSub?.text2 || '',
                                                        Etext: leftSub.text || '',
                                                        Etext2: leftSub.text2 || '',
                                                        Estart: leftSub.start,
                                                        Eend: leftSub.end,
                                                        note: rightSub?.note || leftSub.note || '',
                                                        bookmark: rightSub?.bookmark || leftSub.bookmark || false,
                                                    });
                                                } else if (rightSub) {
                                                    mergedData.push({
                                                        ...rightSub,
                                                        text: rightSub.text || '',
                                                        text2: rightSub.text2 || '',
                                                        Etext: '',
                                                        Etext2: '',
                                                        Estart: '',
                                                        Eend: '',
                                                        note: rightSub.note || '',
                                                        bookmark: rightSub.bookmark || false,
                                                    });
                                                }
                                            }

                                            processedSubtitles = mergedData;
                                        }
                                    } catch (error) {
                                        console.error('Error in dual column merge:', error);
                                        // Keep original data if merge fails
                                    }
                                }
                            } else {
                                // For single column languages, merge with existing if available
                                if (subtitle && subtitle.length > 0) {
                                    const maxLength = Math.max(subtitle.length, stateUpdated.length);
                                    const mergedData = [];

                                    for (let index = 0; index < maxLength; index++) {
                                        const englishSub = subtitle[index];
                                        const newLangSub = stateUpdated[index];

                                        if (newLangSub) {
                                            mergedData.push({
                                                ...newLangSub,
                                                Etext: englishSub?.text || '',
                                                Etext2: englishSub?.text2 || '',
                                                Estart: englishSub?.start || newLangSub.start,
                                                Eend: englishSub?.end || newLangSub.end,
                                            });
                                        } else if (englishSub) {
                                            mergedData.push({
                                                start: englishSub.start,
                                                end: englishSub.end,
                                                text: '',
                                                text2: '',
                                                Etext: englishSub.text || '',
                                                Etext2: englishSub.text2 || '',
                                                Estart: englishSub.start,
                                                Eend: englishSub.end,
                                                note: englishSub.note || '',
                                                bookmark: englishSub.bookmark || false,
                                            });
                                        }
                                    }

                                    processedSubtitles = mergedData;
                                }
                            }

                            // Save with the processed data FIRST
                            console.log('💾 Saving imported subtitles immediately...');
                            const result = await autoSaveFunction({ importedSubtitles: processedSubtitles, importSource: file.name });

                            // THEN update the UI state
                            mergeSubtitleWithEnglish(stateUpdated, selectedLng);

                            if (result.success) {
                                console.log('✅ Import and save completed successfully');
                                // Clear loading state before showing success
                                setLoading('');
                                Swal.fire({
                                    title: '🎉 Import Complete!',
                                    html: `<div style="text-align: center;">
                                        <p style="margin: 10px 0; font-size: 16px;">Your subtitle file has been successfully imported</p>
                                        <p style="margin: 5px 0; color: #666; font-size: 14px;">✓ ${file.name} processed and saved</p>
                                        <p style="margin: 5px 0; color: #666; font-size: 14px;">✓ Ready for editing in ${selectedLng}</p>
                                    </div>`,
                                    icon: 'success',
                                    timer: 3000,
                                    showConfirmButton: false,
                                    background: '#f8f9fa',
                                    customClass: {
                                        popup: 'import-success-popup',
                                    },
                                });
                            } else {
                                console.error('❌ Import save failed:', result.message);
                                // Clear loading state before showing error
                                setLoading('');
                                Swal.fire({
                                    title: '⚠️ Import Failed',
                                    html: `<div style="text-align: center;">
                                        <p style="margin: 10px 0; font-size: 16px;">Unable to save your subtitle file</p>
                                        <p style="margin: 10px 0; color: #666; font-size: 14px;">${result.message}</p>
                                        <p style="margin: 10px 0; color: #888; font-size: 12px;">Please try again or contact support if the issue persists</p>
                                    </div>`,
                                    icon: 'error',
                                    confirmButtonText: 'Try Again',
                                    background: '#fff5f5',
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err.message);
                            // Clear loading state before showing error
                            setLoading('');
                            Swal.fire({
                                title: '📄 File Processing Error',
                                html: `<div style="text-align: center;">
                                    <p style="margin: 10px 0; font-size: 16px;">Could not process the selected file</p>
                                    <p style="margin: 10px 0; color: #666; font-size: 14px;">${err.message}</p>
                                    <p style="margin: 10px 0; color: #888; font-size: 12px;">Please check the file format and try again</p>
                                </div>`,
                                icon: 'error',
                                confirmButtonText: 'Select Another File',
                                background: '#fff5f5',
                            });
                        });
                } else {
                    console.log('Unable to open this subtitle format');
                    Swal.fire({
                        title: '📋 Unsupported File Format',
                        html: `<div style="text-align: center;">
                            <p style="margin: 10px 0; font-size: 16px;">This file type cannot be imported</p>
                            <p style="margin: 10px 0; color: #666; font-size: 14px;">Supported formats:</p>
                            <div style="margin: 15px 0;">
                                <span style="background: #e3f2fd; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.srt</span>
                                <span style="background: #e8f5e8; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.vtt</span>
                                <span style="background: #fff3e0; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.ass</span>
                                <span style="background: #f3e5f5; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.json</span>
                            </div>
                        </div>`,
                        icon: 'warning',
                        confirmButtonText: 'Select Supported File',
                        background: '#fffbf0',
                    });
                }
            }
        },
        [
            setSubtitle,
            clearSubs,
            formatSub,
            autoSaveFunction,
            showDualColumns,
            leftColumnLanguage,
            selectedLng,
            subtitle,
        ],
    );

    const onInputClick = useCallback((event) => {
        event.target.value = '';
    }, []);

    const fetchData = async (selectedLanguage) => {
        let subtitleData = '';
        let videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        let lnguageindex = videoPropsLng.videoLanguages
            .map((item, index) => (item.languageName === selectedLanguage ? index : -1))
            .filter((index) => index !== -1);
        try {
            console.log('Fetching VTT file', videoPropsLng.videoLanguages[lnguageindex[0]].vttFileUrl);

            const vttData = await fetchBlobUrl(videoPropsLng.videoLanguages[lnguageindex[0]].vttFileUrl).catch(
                (error) => {
                    console.error('SubtitleEditor.js Error fetching VTT file:', error);
                },
            );
            if (vttData) {
                videoPropsLng.videoLanguages[lnguageindex[0]].subtitleString = vttData;
                subtitleData = vttData;
            }
        } catch (error) {
            console.log('SubtitleEditor.js  Error fetching VTT file:', error);
        }

        return subtitleData;
    };

    const handleChange = (event) => {
        let selectedLanguage = event.target.value;
        let videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        let lnguageindex = videoPropsLng.videoLanguages
            .map((item, index) => (item.languageName === selectedLanguage ? index : -1))
            .filter((index) => index !== -1);

        if (videoPropsLng.videoLanguages[lnguageindex[0]].status === 'PROCESSING') {
            Swal.fire({
                title: 'Error!',
                text: 'The subtitles for this language are still processing. Come back to this video later',
                icon: 'error',
                confirmButtonText: 'Close',
            });
            return;
        }

        // Get current user and their access level for the selected language
        const user = JSON.parse(localStorage.getItem('authUser'));
        const accessLevel = user?.languageAccess?.[selectedLanguage] || 'READ';
        const hasWriteAccess = accessLevel === 'WRITE' || accessLevel === 'ADMIN';

        console.log(
            `User ${user?.email} has ${accessLevel} access to ${selectedLanguage} (Write access: ${hasWriteAccess})`,
        );
        // Add a log entry for the language change
        addLog(`Changed language to ${selectedLanguage} - User access level: ${accessLevel}`);

        // Snapshot current subtitle to the OLD language key BEFORE switching.
        // This prevents a race where selectedLng updates before subtitle does,
        // causing any subsequent write to corrupt the new language's storage key.
        if (subtitle && subtitle.length > 0) {
            writeSubtitleToStorage(subtitle, selectedLng);
            console.log(`ToolBar: snapshot saved ${subtitle.length} subs for "${selectedLng}" before switching to "${selectedLanguage}"`);
        }
        // Tell V2 editor to cancel any pending debounced writes — we just saved synchronously above.
        window.dispatchEvent(new Event('cancelSubtitleDebounce'));

        setSelectedLng(selectedLanguage);
        setLngIndex(lnguageindex[0]);

        localStorage.setItem('setSelectedLng', JSON.stringify(selectedLanguage));

        setBookmarked(videoPropsLng.videoLanguages[lnguageindex[0]].metadataCheckFlag);
        setSubtitleComment(videoPropsLng.videoLanguages[lnguageindex[0]].metadataComments);

        fetchData(selectedLanguage).then((subtitleData) => {
            const stateUpdated = getSubNodesfromVtt(subtitleData);

            // Check for overlapping subtitles in the selected language
            let overlapCount = 0;
            for (let i = 1; i < stateUpdated.length; i++) {
                const prev = stateUpdated[i - 1];
                const curr = stateUpdated[i];
                if (curr.startTime !== 0 && prev.endTime !== 0 && curr.startTime < prev.endTime) {
                    overlapCount++;
                }
            }
            if (overlapCount > 0) {
                Swal.fire({
                    title: 'Overlapping Subtitles Detected',
                    html: `<p>The <strong>${selectedLanguage}</strong> subtitles have <strong>${overlapCount}</strong> overlapping subtitle${overlapCount === 1 ? '' : 's'}.</p><p style="color:#888;font-size:13px;margin-top:8px;">Please review and fix the overlaps in the editor.</p>`,
                    icon: 'warning',
                    confirmButtonText: 'OK',
                });
            }

            // Pass selectedLanguage explicitly to avoid stale closure values inside
            // mergeSubtitleWithEnglish (showDualColumns / selectedLng may not have
            // updated yet when this async .then() callback fires).
            mergeSubtitleWithEnglish(stateUpdated, selectedLanguage);
        });
    };

    const onLoad = useCallback(async () => {
        const pagebreadcrumbs = JSON.parse(localStorage.getItem('breadcrumbs'));
        setBreadcrumb(pagebreadcrumbs);

        const videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
        try {
            videoCRUDServiceInstance
                .getVideoDataOfId(videoPropsLng.id)
                .then((response) => {
                    const languagesList = response.data.videoLanguages.map((item) => item.languageName);
                    const uniqueLanguages = Array.from(new Set(languagesList));
                    setLanguages(uniqueLanguages);
                    localStorage.setItem('videoProps', JSON.stringify(response.data));
                })
                .catch((e) => {
                    console.log('ERROR', e);
                });
        } catch (e) {
            console.log('ERROR', e);
            const videoPropsLng = JSON.parse(localStorage.getItem('videoProps'));
            const languagesList = videoPropsLng.videoLanguages.map((item) => item.languageName);
            const uniqueLanguages = Array.from(new Set(languagesList));
            setLanguages(uniqueLanguages);
        }
    }, []);

    const onUnload = useCallback(() => {
        localStorage.removeItem('setSelectedLng');
    }, []);

    useEffect(() => {
        clearLogs();
    }, []);

    useEffect(() => {
        const pagebreadcrumbs = JSON.parse(localStorage.getItem('breadcrumbs'));
        setBreadcrumb(pagebreadcrumbs);
        window.addEventListener('load', onLoad);
        return () => {
            if (window !== null) {
                window.removeEventListener('load', onLoad);
            }
        };
    }, [onLoad]);

    useEffect(() => {
        window.addEventListener('focus', onLoad);
        window.addEventListener('beforeunload', onUnload);

        // Check initial access level for the selected language
        const user = JSON.parse(localStorage.getItem('authUser'));
        const accessLevel = user?.languageAccess?.[selectedLng] || 'READ';
        // Update UI based on access level - now checking for both WRITE and ADMIN
        const hasWriteAccess = accessLevel === 'WRITE' || accessLevel === 'ADMIN';

        // Only set up auto-save interval if user has WRITE or ADMIN access
        let interval;
        if (hasWriteAccess) {
            interval = setInterval(async () => {
                const result = await onAutoSave({ isAutoSave: true });
                // Optional logging based on result
                if (!result?.success) {
                    console.log('Auto-save failed:', result?.message || 'Unknown error');
                }
            }, 30000);
        } else {
            //console.log(`Auto-save disabled for ${selectedLng} - User ${user?.email} has Read access`);
            addLog(`Auto-save disabled for ${selectedLng} - User has Read access`);
        }

        return () => {
            if (interval) {
                clearInterval(interval);
            }
            if (window !== null) {
                window.removeEventListener('focus', onLoad);
                window.removeEventListener('beforeunload', onUnload);
            }
        };
    }, [selectedLng, subtitleComment, bookmarked, onAutoSave]); // Add onAutoSave to dependencies

    // Inside your component
    const handleBreadcrumbNavigate = ({ path }) => {
        console.log(`Navigating to breadcrumb path: ${path}`);

        // Update breadcrumbs in localStorage if needed
        const newBreadcrumbs = path.split('/').filter((segment) => segment.length > 0);
        localStorage.setItem('breadcrumbs', JSON.stringify(newBreadcrumbs));

        // Navigate with state
        navigate('/', {
            state: {
                fromVideoEdit: true,
                folderPath: path,
                refreshNeeded: true,
            },
        });
    };

    // Add this effect to fetch sections when the language changes
    useEffect(() => {
        const fetchSections = async () => {
            if (!selectedLng) return;

            const videoProps = JSON.parse(localStorage.getItem('videoProps'));
            if (!videoProps || !videoProps.id) return;

            setLoadingSections(true);
            setSectionError(null);

            try {
                const response = await sectionManagementService.getSections(videoProps.id, selectedLng);
                setSections(response.data || []);

                // Clear selected section when changing languages
                setSelectedSection(null);
            } catch (err) {
                console.error('Error fetching sections:', err);
                setSections([]);
            } finally {
                setLoadingSections(false);
            }
        };

        fetchSections();
    }, [selectedLng]);

    // Add this useEffect hook after other state definitions in BugReportForm.js
    // Add this function after other utility functions in ToolBar.js

    const openBugReportWithCurrentVideo = () => {
        // Store the current video data in localStorage to be picked up by the form
        const videoProps = JSON.parse(localStorage.getItem('videoProps'));

        if (!videoProps) {
            // No video is currently loaded
            Swal.fire({
                title: 'No Video Selected',
                text: 'Please open a video before reporting an issue.',
                icon: 'warning',
                confirmButtonText: 'OK',
            });
            return;
        }

        // Get current language
        const currentLanguage = selectedLng || '';

        // Format path from breadcrumb
        const formattedPath = breadcrumb && breadcrumb.length > 0 ? `/${breadcrumb.join('/')}` : '/';

        // Determine which subtitle editor the user is in (V2 overrides V1)
        const currentPath = window.location?.pathname || '';
        let editorVersion = null;
        if (currentPath.includes('/videos/edit-v2')) {
            editorVersion = 'V2';
        } else if (currentPath.includes('/videos/edit')) {
            editorVersion = 'V1';
        }

        // Create a prefill object with all necessary information
        const prefillData = {
            category: 'editing_video',
            videoName: videoProps.videoName,
            videoId: videoProps.id,
            folderPath: formattedPath,
            languages: currentLanguage,
            editorVersion: editorVersion,
        };

        // Store in localStorage for the bug report form to pick up
        localStorage.setItem('bugReportPrefill', JSON.stringify(prefillData));

        // Navigate to the bug report page
        window.open('/bug-report', '_blank');
    };

    // Add this function to handle section selection
    const handleSectionChange = async (event) => {
        const videoProps = JSON.parse(localStorage.getItem('videoProps'));
        if (!videoProps || !videoProps.id) return;

        const sectionId = event.target.value;

        // If "None" is selected, reset to the full subtitle
        if (sectionId === 'none') {
            setSelectedSection(null);

            // Reload the full VTT for this language
            let lnguageindex = videoProps.videoLanguages
                .map((item, index) => (item.languageName === selectedLng ? index : -1))
                .filter((index) => index !== -1);

            if (lnguageindex.length > 0) {
                try {
                    setLoading('Loading full subtitle...');
                    const vttData = await fetchBlobUrl(videoProps.videoLanguages[lnguageindex[0]].vttFileUrl);
                    if (vttData) {
                        const stateUpdated = getSubNodesfromVtt(vttData);
                        setSubtitle(
                            stateUpdated.map((item) => formatSub(item)),
                            false,
                        );
                    }
                    setLoading('');
                } catch (error) {
                    console.error('Error loading full VTT:', error);
                    setLoading('');
                }
            }
            return;
        }

        // Find the selected section
        const section = sections.find((s) => s.id === sectionId);
        if (!section) return;

        // Start editing this section
        try {
            setLoading('Loading section...');

            const response = await sectionManagementService.startSectionEditing(videoProps.id, selectedLng, sectionId);

            if (response.data && response.data.vttFileUrl) {
                // Load the section VTT content
                const vttData = await fetchBlobUrl(response.data.vttFileUrl);
                if (vttData) {
                    const stateUpdated = getSubNodesfromVtt(vttData);
                    setSubtitle(
                        stateUpdated.map((item) => formatSub(item)),
                        false,
                    );
                    setSelectedSection(response.data);

                    // Add a log entry that we're editing a section
                    addLog(`Editing section: ${response.data.name}`);
                }
            }
            setLoading('');
        } catch (err) {
            console.error('Error starting section edit:', err);
            setSectionError(`Failed to start editing section: ${err.message}`);

            // Show error to user
            Swal.fire({
                title: 'Error',
                text: `Failed to load section: ${err.message}`,
                icon: 'error',
            });
            setLoading('');
        }
    };

    // Add function to end section editing
    const endSectionEditing = async () => {
        if (!selectedSection) return;

        const videoProps = JSON.parse(localStorage.getItem('videoProps'));
        if (!videoProps || !videoProps.id) return;

        try {
            setLoading('Ending section editing...');

            // Save current work first (prefer storage helper fallback)
            const currentSubtitles = readSubtitleFromStorage(selectedLng) || subtitle;

            if (currentSubtitles && currentSubtitles.length > 0) {
                // Generate VTT content from subtitles
                let vttContent = 'WEBVTT\n\n';

                for (const sub of currentSubtitles) {
                    if (sub.start === '00:00:00' && sub.end === '00:00:00') continue;

                    vttContent += `${sub.start} --> ${sub.end}\n`;
                    vttContent += `${sub.text2}\n\n`;
                }

                // Save to the section
                await sectionManagementService.saveSection(videoProps.id, selectedLng, selectedSection.id, vttContent);
            }

            // End the editing session
            await sectionManagementService.endSectionEditing(videoProps.id, selectedLng, selectedSection.id);

            setSelectedSection(null);

            // Reload the full VTT
            let lnguageindex = videoProps.videoLanguages
                .map((item, index) => (item.languageName === selectedLng ? index : -1))
                .filter((index) => index !== -1);

            if (lnguageindex.length > 0) {
                const vttData = await fetchBlobUrl(videoProps.videoLanguages[lnguageindex[0]].vttFileUrl);
                if (vttData) {
                    const stateUpdated = getSubNodesfromVtt(vttData);
                    setSubtitle(
                        stateUpdated.map((item) => formatSub(item)),
                        false,
                    );
                }
            }

            addLog('Section editing ended');
            setLoading('');
        } catch (err) {
            console.error('Error ending section edit:', err);
            Swal.fire({
                title: 'Error',
                text: `Failed to end section editing: ${err.message}`,
                icon: 'error',
            });
            setLoading('');
        }
    };

    // Create the section dropdown JSX
    const sectionDropdown = (
        <>
            {sections.length > 0 && (
                <FormControl
                    sx={{
                        width: '15%',
                        mr: 1,
                        minHeight: '35px',
                        alignSelf: 'center',
                        '& .MuiInputBase-root': {
                            height: '35px',
                            backgroundColor: selectedSection ? 'rgba(33, 150, 243, 0.2)' : 'rgba(255, 255, 255, 0.08)',
                            borderRadius: '4px',
                            color: '#fff',
                            border: '1px solid rgba(255, 255, 255, 0.23)',
                        },
                        '& .MuiSelect-icon': {
                            color: 'rgba(255, 255, 255, 0.7)',
                        },
                        '& .MuiInputLabel-root': {
                            color: 'rgba(255, 255, 255, 0.7)',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#90caf9',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(255, 255, 255, 0.23)',
                        },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(255, 255, 255, 0.5)',
                        },
                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#90caf9',
                        },
                    }}
                    size="small"
                    variant="outlined"
                >
                    <InputLabel id="section-select-label" sx={{ fontSize: '0.85rem' }}>
                        {loadingSections ? 'Loading...' : 'Section'}
                    </InputLabel>
                    <Select
                        labelId="section-select-label"
                        id="sectionSelector"
                        value={selectedSection ? selectedSection.id : 'none'}
                        onChange={handleSectionChange}
                        label={loadingSections ? 'Loading...' : 'Section'}
                        disabled={loadingSections || readOnly}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 300,
                                    backgroundColor: '#212121',
                                    color: '#fff',
                                    borderRadius: '4px',
                                    border: '1px solid rgba(255, 255, 255, 0.12)',
                                },
                            },
                        }}
                        renderValue={(selected) => {
                            if (selected === 'none') {
                                return <em style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Full Subtitle</em>;
                            }

                            const section = sections.find((s) => s.id === selected);
                            if (!section) return <em style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Full Subtitle</em>;

                            return (
                                <MuiBox sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <SplitscreenIcon fontSize="small" sx={{ color: '#90caf9' }} />
                                    <span>{section.name}</span>
                                </MuiBox>
                            );
                        }}
                    >
                        <MenuItem value="none" sx={{ '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.08)' } }}>
                            <em>Full Subtitle</em>
                        </MenuItem>

                        {sections.map((section) => {
                            const isLocked =
                                section.locked &&
                                section.activeEditor !== JSON.parse(localStorage.getItem('authUser'))?.email;

                            return (
                                <MenuItem
                                    key={section.id}
                                    value={section.id}
                                    disabled={isLocked}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.08)' },
                                        '&.Mui-selected': {
                                            backgroundColor: 'rgba(144, 202, 249, 0.16)',
                                            '&:hover': { backgroundColor: 'rgba(144, 202, 249, 0.24)' },
                                        },
                                        '&.Mui-disabled': {
                                            opacity: 0.5,
                                            color: 'rgba(255, 255, 255, 0.5)',
                                        },
                                    }}
                                >
                                    <span>{section.name}</span>

                                    {isLocked && (
                                        <Chip
                                            label={`Locked by ${section.activeEditor}`}
                                            size="small"
                                            color="warning"
                                            sx={{
                                                ml: 1,
                                                fontSize: '0.7rem',
                                                backgroundColor: 'rgba(237, 108, 2, 0.16)',
                                                color: '#ffb74d',
                                                borderColor: 'rgba(237, 108, 2, 0.5)',
                                            }}
                                        />
                                    )}

                                    {section.locked &&
                                        section.activeEditor ===
                                            JSON.parse(localStorage.getItem('authUser'))?.email && (
                                            <Chip
                                                label="You are editing"
                                                size="small"
                                                color="primary"
                                                sx={{
                                                    ml: 1,
                                                    fontSize: '0.7rem',
                                                    backgroundColor: 'rgba(33, 150, 243, 0.16)',
                                                    color: '#90caf9',
                                                    borderColor: 'rgba(33, 150, 243, 0.5)',
                                                }}
                                            />
                                        )}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            )}

            {selectedSection && (
                <Tooltip title="End section editing and return to full subtitle">
                    <Button
                        onClick={endSectionEditing}
                        variant="outlined"
                        size="small"
                        startIcon={<ExitToAppIcon />}
                        sx={{
                            height: '35px',
                            minHeight: '35px',
                            mr: 1,
                            alignSelf: 'center',
                            color: '#f44336',
                            borderColor: 'rgba(244, 67, 54, 0.5)',
                            backgroundColor: 'rgba(244, 67, 54, 0.08)',
                            '&:hover': {
                                backgroundColor: 'rgba(244, 67, 54, 0.16)',
                                borderColor: '#f44336',
                            },
                        }}
                    >
                        Exit Section
                    </Button>
                </Tooltip>
            )}
        </>
    );

    const handleShowReplace = () => {
        setShowReplace((prev) => !prev);
    };

    const searchDebounceTimer = useRef(null);

    // Similarly, update the Hindi/Gujarati input handler
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputText1(value);
        setLnagText1(value);

        // Clear any existing timer
        if (searchDebounceTimer.current) {
            clearTimeout(searchDebounceTimer.current);
        }

        // Set a new timer to delay the actual search execution
        searchDebounceTimer.current = setTimeout(() => {
            handleSearchTermChange(value);
        }, 500); // 500ms delay
    };

    const handleSearchTermChange = (term) => {
        setSearchTerm(term);

        // Clear any existing timer
        if (searchDebounceTimer.current) {
            clearTimeout(searchDebounceTimer.current);
        }

        // Set a new timer to delay the actual search execution
        searchDebounceTimer.current = setTimeout(() => {
            if (typeof onSearchTermChange === 'function') {
                onSearchTermChange(term);
            }
        }, 500); // 500ms delay before executing search
    };

    const handleReplaceTermChange = (term) => {
        setReplaceTerm(term);
        if (typeof onReplaceTermChange === 'function') {
            onReplaceTermChange(term);
        }
    };

    // Update effects to sync with parent props if needed
    useEffect(() => {
        if (parentSearchTerm !== undefined) {
            setSearchTerm(parentSearchTerm);
        }
    }, [parentSearchTerm]);

    useEffect(() => {
        if (parentReplaceTerm !== undefined) {
            setReplaceTerm(parentReplaceTerm);
        }
    }, [parentReplaceTerm]);

    // Add this useEffect to clean up the timer when component unmounts
    useEffect(() => {
        return () => {
            if (searchDebounceTimer.current) {
                clearTimeout(searchDebounceTimer.current);
            }
        };
    }, []);

    // Add this function inside your Header component, after the state variables
    const handleSearchClick = () => {
        // Toggle search drawer
        if (typeof handleShowSearch === 'function') {
            handleShowSearch();

            // If opening the search, focus the input after a slight delay to allow animation
            if (!showSearch) {
                setTimeout(() => {
                    const searchInput = document.querySelector('.searchboxs.open input');
                    if (searchInput) {
                        searchInput.focus();
                    }
                }, 300);
            }
        } else {
            // Fallback if the prop is not available
            setShowSearch((prev) => !prev);
        }
    };

    // Transcript import handlers
    const handleImportTranscript = () => {
        if (transcriptFileInputRef.current) {
            transcriptFileInputRef.current.click();
        }
    };

    const onTranscriptFileChange = useCallback(async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const ext = getExt(file.name);
        const supportedFormats = ['txt', 'srt', 'vtt', 'json'];

        if (!supportedFormats.includes(ext)) {
            Swal.fire({
                title: '📄 Unsupported File Format',
                html: `<div style="text-align: center;">
                    <p style="margin: 10px 0; font-size: 16px;">This file type cannot be imported as a transcript</p>
                    <p style="margin: 10px 0; color: #666; font-size: 14px;">Supported formats:</p>
                    <div style="margin: 15px 0;">
                        <span style="background: #e3f2fd; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.txt</span>
                        <span style="background: #e3f2fd; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.srt</span>
                        <span style="background: #e3f2fd; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.vtt</span>
                        <span style="background: #e3f2fd; padding: 4px 8px; border-radius: 4px; margin: 0 4px; font-family: monospace;">.json</span>
                    </div>
                </div>`,
                icon: 'error',
                confirmButtonText: 'Select Another File',
                background: '#fff5f5',
            });
            return;
        }

        setLoading(`Processing transcript\n\n${file.name.split('.')[0]}\nPlease wait...`);

        try {
            let transcriptText = '';

            if (ext === 'txt') {
                // Read as plain text
                transcriptText = await readFileAsText(file);
            } else if (ext === 'srt' || ext === 'vtt') {
                // Extract text from subtitle files
                const subtitleContent = await readFileAsText(file);
                transcriptText = extractTextFromSubtitles(subtitleContent, ext);
            } else if (ext === 'json') {
                // Parse JSON and extract text
                const jsonContent = await readFileAsText(file);
                transcriptText = extractTextFromJSON(jsonContent);
            }

            if (!transcriptText.trim()) {
                throw new Error('No text content found in the file');
            }

            // Get current language
            const currentLanguage = selectedLng || 'English';

            // Get video duration from player
            let videoDuration = null;
            if (player && player.element && player.element.duration) {
                videoDuration = player.element.duration;
                console.log('Using video duration:', videoDuration, 'seconds');
            } else {
                console.log('Video duration not available, will use default timing');
            }

            // Process the transcript using our segmentation utility
            const result = processTranscript(transcriptText, currentLanguage, {
                maxCharsPerLine: 35,
                maxLines: 2,
                startTime: 0,
                estimatedDuration: videoDuration // Use actual video duration
            });

            if (!result.success) {
                throw new Error(result.error);
            }

            // Convert segments to subtitle format that matches the existing structure
            const processedSubtitles = result.subtitles.map((item, index) => {
                return {
                    start: item.start,
                    end: item.end,
                    text: item.text,
                    text2: item.text2,
                    Estart: item.start,
                    Eend: item.end,
                    Etext: item.text,
                    Etext2: item.text2,
                    note: item.note,
                    bookmark: item.bookmark,
                    duration: item.duration,
                    startTime: item.startTime,
                    endTime: item.endTime
                };
            });

            // Save the processed transcript
            const saveResult = await autoSaveFunction({ 
                importedSubtitles: processedSubtitles, 
                importSource: `transcript-${file.name}` 
            });

            // Update the UI state
            setSubtitle(processedSubtitles.map((item) => new Sub(item)));

            setLoading('');

            if (saveResult.success) {
                Swal.fire({
                    title: '🎉 Transcript Import Complete!',
                    html: `<div style="text-align: center;">
                        <p style="margin: 10px 0; font-size: 16px;">Your transcript has been successfully processed</p>
                        <div style="margin: 15px 0; padding: 10px; background: #f0f8ff; border-radius: 5px;">
                            <p style="margin: 5px 0; color: #0066cc;"><strong>Language:</strong> ${currentLanguage}</p>
                            <p style="margin: 5px 0; color: #0066cc;"><strong>Segments Created:</strong> ${result.totalSegments}</p>
                            <p style="margin: 5px 0; color: #0066cc;"><strong>Max Chars per Line:</strong> 35</p>
                            <p style="margin: 5px 0; color: #0066cc;"><strong>Max Lines per Segment:</strong> 2</p>
                            ${videoDuration ? 
                                `<p style="margin: 5px 0; color: #0066cc;"><strong>Video Duration:</strong> ${Math.floor(videoDuration / 60)}:${Math.floor(videoDuration % 60).toString().padStart(2, '0')}</p>
                                <p style="margin: 5px 0; color: #0066cc;"><strong>Average Segment Duration:</strong> ${(videoDuration / result.totalSegments).toFixed(1)}s</p>` : 
                                '<p style="margin: 5px 0; color: #0066cc;"><strong>Duration:</strong> Default timing (3s per segment)</p>'
                            }
                        </div>
                        <p style="margin: 10px 0; color: #666; font-size: 14px;">The transcript has been automatically segmented ${videoDuration ? 'and distributed across the video duration' : 'with default timing'}.</p>
                    </div>`,
                    icon: 'success',
                    confirmButtonText: 'Continue Editing',
                    background: '#f0fff0',
                });
            }
        } catch (error) {
            console.error('Error processing transcript:', error);
            setLoading('');
            Swal.fire({
                title: '❌ Import Error',
                html: `<div style="text-align: center;">
                    <p style="margin: 10px 0; font-size: 16px;">Failed to process the transcript file</p>
                    <p style="margin: 10px 0; color: #d32f2f; font-size: 14px;">${error.message}</p>
                    <p style="margin: 10px 0; color: #888; font-size: 12px;">Please check the file format and try again</p>
                </div>`,
                icon: 'error',
                confirmButtonText: 'Try Again',
                background: '#fff5f5',
            });
        }

        // Reset file input
        event.target.value = '';
    }, [selectedLng, setSubtitle, autoSaveFunction, setLoading, player]);

    // Helper function to read file as text
    const readFileAsText = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event) => resolve(event.target.result);
            reader.onerror = (error) => reject(error);
            reader.readAsText(file, 'utf-8');
        });
    };

    // Helper function to extract text from subtitle files
    const extractTextFromSubtitles = (content, format) => {
        if (format === 'srt') {
            return content
                .split('\n\n')
                .map(block => {
                    const lines = block.trim().split('\n');
                    return lines.slice(2).join(' '); // Skip index and timestamp lines
                })
                .filter(text => text.trim())
                .join(' ');
        } else if (format === 'vtt') {
            return content
                .replace(/^WEBVTT\s*$/m, '')
                .split('\n\n')
                .map(block => {
                    const lines = block.trim().split('\n');
                    const textLines = lines.filter(line => !line.includes('-->') && !line.match(/^\d+$/));
                    return textLines.join(' ');
                })
                .filter(text => text.trim())
                .join(' ');
        }
        return content;
    };

    // Helper function to extract text from JSON
    const extractTextFromJSON = (jsonContent) => {
        try {
            const data = JSON.parse(jsonContent);
            if (Array.isArray(data)) {
                return data.map(item => item.text || '').join(' ');
            } else if (data.text) {
                return data.text;
            } else if (data.transcript) {
                return data.transcript;
            }
            return '';
        } catch (error) {
            throw new Error('Invalid JSON format');
        }
    };

    // Rest of the component...

    // Return JSX with search functionality
    return (
        <Style className="tool">
            <div className="top">
                <div className="operate">
                    <div className="breadcrumb" id="efitb">
                        <Box
                            className="header-container"
                            ref={headerContainerRef}
                            sx={{
                                display: 'flex',
                                width: '100%',
                                flexDirection: { xs: 'column', sm: 'row' },
                            }}
                        >
                            {/* Right side column with title/subtitle and breadcrumbs */}
                            <Box
                                className="right-section"
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                }}
                            >
                                {/* Top row with title and subtitle */}
                                <Box
                                    className="top-row"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        mb: { xs: 0.5, sm: 0.75 },
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Typography
                                        className="user-info"
                                        variant="subtitle1"
                                        sx={{
                                            color: 'rgba(255, 255, 255, 0.8)',
                                            fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                            lineHeight: 1.2,
                                            marginLeft: { xs: 0, sm: '0.5rem' },
                                            marginRight: '0.5rem',
                                        }}
                                    >
                                        {user.email ? formatUserName(user.email) : 'Guest'}
                                    </Typography>

                                    {selectedLng && (
                                        <Box
                                            component="span"
                                            className="language-badge"
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                backgroundColor:
                                                    user?.languageAccess?.[selectedLng] === 'WRITE' ||
                                                    user?.languageAccess?.[selectedLng] === 'ADMIN'
                                                        ? 'rgba(76, 175, 80, 0.2)'
                                                        : 'rgba(255, 152, 0, 0.2)',
                                                color:
                                                    user?.languageAccess?.[selectedLng] === 'WRITE' ||
                                                    user?.languageAccess?.[selectedLng] === 'ADMIN'
                                                        ? '#4caf50'
                                                        : '#ff9800',
                                                borderRadius: '4px',
                                                padding: { xs: '0px 4px', sm: '0px 8px' },
                                                marginLeft: '8px',
                                                fontSize: { xs: '0.65rem', sm: '0.7rem' },
                                                fontWeight: 'bold',
                                                border: '1px solid',
                                                borderColor:
                                                    user?.languageAccess?.[selectedLng] === 'WRITE' ||
                                                    user?.languageAccess?.[selectedLng] === 'ADMIN'
                                                        ? 'rgba(76, 175, 80, 0.5)'
                                                        : 'rgba(255, 152, 0, 0.5)',
                                            }}
                                        >
                                            {user?.languageAccess?.[selectedLng] === 'WRITE' ||
                                            user?.languageAccess?.[selectedLng] === 'ADMIN'
                                                ? 'EDIT'
                                                : 'READ'}
                                        </Box>
                                    )}
                                </Box>

                                {/* Bottom row with breadcrumbs */}
                                <Box
                                    className="breadcrumb-row"
                                    sx={{
                                        width: '100%',
                                        overflow: 'hidden',
                                    }}
                                >
                                    <ModernBreadcrumbs
                                        currentPath={currentPath}
                                        onNavigate={handleBreadcrumbNavigate}
                                        isDarkBackground={true}
                                        maxItems={containerWidth > 530 ? 3 : 2}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </div>
                    {/* Replace the full toolbar buttons section with this consistent styling */}
                    {/* Search Box */}
                    <div className={showSearch ? 'searchboxs open' : 'searchboxs'}>
                        <div className="searchboxlist">
                            <ul>
                                <li className="search-input">
                                    {selectedLng === 'Hindi' || selectedLng === 'Gujarati' ? (
                                        <input
                                            type="text"
                                            placeholder="Find text in subtitles..."
                                            value={inputText1}
                                            onChange={handleInputChange}
                                            autoFocus
                                        />
                                    ) : (
                                        <input
                                            type="text"
                                            placeholder="Find text in subtitles..."
                                            value={searchTerm}
                                            onChange={(e) => {
                                                setSearchTerm(e.target.value);

                                                // Clear any existing timer
                                                if (searchDebounceTimer.current) {
                                                    clearTimeout(searchDebounceTimer.current);
                                                }

                                                // Set a new timer to delay the actual search execution
                                                searchDebounceTimer.current = setTimeout(() => {
                                                    handleSearchTermChange(e.target.value);
                                                }, 500); // 500ms delay
                                            }}
                                            autoFocus
                                        />
                                    )}
                                </li>
                                <li>
                                    <span>
                                        {matchOffsets && matchOffsets.length > 0
                                            ? `Match ${currentMatchIndex + 1} of ${matchOffsets.length}`
                                            : 'No results'}
                                    </span>
                                    <button
                                        className="updown-navs"
                                        onClick={goToPreviousMatch}
                                        disabled={!matchOffsets || matchOffsets.length === 0}
                                    >
                                        <ArrowUpwardIcon />
                                    </button>
                                    <button
                                        className="updown-navs"
                                        onClick={goToNextMatch}
                                        disabled={!matchOffsets || matchOffsets.length === 0}
                                    >
                                        <ArrowDownwardIcon />
                                    </button>
                                    <button className="colsesearch" onClick={handleShowSearch}>
                                        <CloseIcon />
                                    </button>
                                </li>
                                <li>
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={handleShowReplace}
                                        sx={{
                                            borderColor: 'rgba(255, 255, 255, 0.3)',
                                            color: '#fff',
                                            marginLeft: '8px',
                                            minWidth: '100px',
                                        }}
                                    >
                                        {showReplace ? 'Hide Replace' : 'Show Replace'}
                                    </Button>
                                </li>
                            </ul>
                            {showReplace && (
                                <ul>
                                    <li className="search-input">
                                        {selectedLng === 'Hindi' || selectedLng === 'Gujarati' ? (
                                            <input
                                                type="text"
                                                placeholder="Replace with..."
                                                value={inputText2}
                                                onChange={(e) => {
                                                    setInputText2(e.target.value);
                                                    handleReplaceTermChange(e.target.value);
                                                }}
                                            />
                                        ) : (
                                            <input
                                                type="text"
                                                placeholder="Replace with..."
                                                value={replaceTerm}
                                                onChange={(e) => {
                                                    setReplaceTerm(e.target.value);
                                                    handleReplaceTermChange(e.target.value);
                                                }}
                                            />
                                        )}
                                    </li>
                                    <li>
                                        <div className="buttons">
                                            <button onClick={handleReplace}>Replace</button>
                                            <button onClick={handleReplaceAll}>Replace All</button>
                                        </div>
                                    </li>
                                </ul>
                            )}
                        </div>
                    </div>
                    <div className="operate">
                        <div className="right-buttons">
                            <Box className="operate" sx={{ display: 'flex', width: '100%' }}>
                                <Grid
                                    container
                                    justifyContent="flex-end"
                                    spacing={1}
                                    alignItems="center"
                                    sx={{ flexWrap: 'nowrap' }}
                                >
                                    {/* Search button */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Search">
                                            <Button
                                                color="inherit"
                                                onClick={handleSearchClick}
                                                sx={{
                                                    minWidth: 'auto',
                                                    padding: '6px',
                                                    height: '35px',
                                                }}
                                            >
                                                <SearchIcon fontSize="small" />
                                            </Button>
                                        </Tooltip>
                                    </Grid>

                                    {/* Maintenance admin button moved to SystemStatusPage */}

                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        {/* Language dropdown */}
                                        <Tooltip
                                            title={isLanguageChangeBlocked ? 'Wait for video to finish loading' : ''}
                                            disableHoverListener={!isLanguageChangeBlocked}
                                            arrow
                                        >
                                            <span>
                                                <FormControl
                                                    sx={{
                                                        width: '120px',
                                                        '& .MuiOutlinedInput-root': {
                                                            backgroundColor: '#252526',
                                                            color: '#cccccc',
                                                            height: '35px',
                                                        },
                                                    }}
                                                    size="small"
                                                >
                                                    <Select
                                                        id="languagesToEdit"
                                                        onChange={handleChange}
                                                        value={selectedLng}
                                                        disabled={isLanguageChangeBlocked}
                                                    >
                                                        {getLanguagesForEditView()?.map((item, index) => (
                                                            <MenuItem key={index} value={item} selected={item === 'English'}>
                                                                {item}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </span>
                                        </Tooltip>
                                    </Grid>

                                    {/* Add Three Dots Menu Button */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Dual Column Settings">
                                            <Button
                                                color="inherit"
                                                onClick={handleDualColumnMenuClick}
                                                sx={{
                                                    minWidth: 'auto',
                                                    padding: '6px',
                                                    height: '35px',
                                                    color: '#cccccc',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                                    },
                                                }}
                                            >
                                                <MoreVertIcon fontSize="small" />
                                            </Button>
                                        </Tooltip>
                                    </Grid>

                                    {/* Dual Column Settings Drawer */}
                                    <div className={showDualColumnDrawer ? 'dualcolumnbox open' : 'dualcolumnbox'}>
                                        <div className="dualcolumnlist">
                                            <div className="drawer-content">
                                                <div className="controls-row">
                                                    {/* Header */}
                                                    <div className="drawer-header">
                                                        <h3>Advanced Settings</h3>
                                                    </div>

                                                    {/* Import Transcript Button */}
                                                    <div className="transcript-import-section">
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            startIcon={<DescriptionIcon />}
                                                            onClick={handleImportTranscript}
                                                            sx={{
                                                                color: '#ffffff',
                                                                borderColor: 'rgba(255, 255, 255, 0.3)',
                                                                fontSize: '0.75rem',
                                                                padding: '4px 8px',
                                                                marginBottom: '10px',
                                                                '&:hover': {
                                                                    borderColor: '#007acc',
                                                                    backgroundColor: 'rgba(0, 122, 204, 0.1)',
                                                                },
                                                            }}
                                                        >
                                                            Import Transcript
                                                        </Button>
                                                        <input
                                                            type="file"
                                                            ref={transcriptFileInputRef}
                                                            onChange={onTranscriptFileChange}
                                                            accept=".txt,.srt,.vtt,.json"
                                                            style={{ display: 'none' }}
                                                        />
                                                    </div>

                                                    {/* Language dropdowns - only show if dual columns is enabled */}
                                                    {showDualColumns && (
                                                        <div className="language-selectors">
                                                            <div className="language-group">
                                                                <label className="language-label">Left Column:</label>
                                                                <FormControl
                                                                    sx={{
                                                                        width: '100%',
                                                                        minWidth: '100px',
                                                                        '& .MuiOutlinedInput-root': {
                                                                            backgroundColor: 'rgba(51, 51, 51, 0.7)',
                                                                            color: '#fff',
                                                                            height: '28px' /* Smaller height */,
                                                                            fontSize: '0.75rem' /* Smaller font */,
                                                                            '& fieldset': {
                                                                                borderColor: 'rgba(255, 255, 255, 0.3)',
                                                                            },
                                                                            '&:hover fieldset': {
                                                                                borderColor: 'rgba(255, 255, 255, 0.5)',
                                                                            },
                                                                            '&.Mui-focused fieldset': {
                                                                                borderColor: '#007acc',
                                                                            },
                                                                        },
                                                                        '& .MuiSelect-icon': {
                                                                            color: 'rgba(255, 255, 255, 0.7)',
                                                                        },
                                                                        '& .MuiSelect-select': {
                                                                            fontSize:
                                                                                '0.75rem' /* Smaller font for selected text */,
                                                                        },
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    <Select
                                                                        value={leftColumnLanguage}
                                                                        onChange={(e) =>
                                                                            setLeftColumnLanguage(e.target.value)
                                                                        }
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                style: {
                                                                                    backgroundColor: '#2d2d30',
                                                                                    color: '#fff',
                                                                                    border: '1px solid rgba(255, 255, 255, 0.12)',
                                                                                    fontSize:
                                                                                        '0.75rem' /* Smaller font in menu */,
                                                                                },
                                                                            },
                                                                        }}
                                                                    >
                                                                        {getLanguagesForEditView()?.map((lang) => (
                                                                            <MenuItem
                                                                                key={lang}
                                                                                value={lang}
                                                                                sx={{
                                                                                    fontSize:
                                                                                        '0.75rem' /* Smaller font for menu items */,
                                                                                    '&:hover': {
                                                                                        backgroundColor:
                                                                                            'rgba(255, 255, 255, 0.08)',
                                                                                    },
                                                                                }}
                                                                            >
                                                                                {lang}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </div>

                                                            <div className="language-group">
                                                                <label className="language-label">Right Column:</label>
                                                                <FormControl
                                                                    sx={{
                                                                        width: '100%',
                                                                        minWidth: '100px',
                                                                        '& .MuiOutlinedInput-root': {
                                                                            backgroundColor: 'rgba(51, 51, 51, 0.7)',
                                                                            color: '#fff',
                                                                            height: '28px' /* Smaller height */,
                                                                            fontSize: '0.75rem' /* Smaller font */,
                                                                            '& fieldset': {
                                                                                borderColor: 'rgba(255, 255, 255, 0.3)',
                                                                            },
                                                                            '&:hover fieldset': {
                                                                                borderColor: 'rgba(255, 255, 255, 0.5)',
                                                                            },
                                                                            '&.Mui-focused fieldset': {
                                                                                borderColor: '#007acc',
                                                                            },
                                                                        },
                                                                        '& .MuiSelect-icon': {
                                                                            color: 'rgba(255, 255, 255, 0.7)',
                                                                        },
                                                                        '& .MuiSelect-select': {
                                                                            fontSize:
                                                                                '0.75rem' /* Smaller font for selected text */,
                                                                        },
                                                                    }}
                                                                    size="small"
                                                                >
                                                                    <Select
                                                                        value={rightColumnLanguage}
                                                                        onChange={(e) =>
                                                                            setRightColumnLanguage(e.target.value)
                                                                        }
                                                                        disabled={true}
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                style: {
                                                                                    backgroundColor: '#2d2d30',
                                                                                    color: '#fff',
                                                                                    border: '1px solid rgba(255, 255, 255, 0.12)',
                                                                                    fontSize:
                                                                                        '0.75rem' /* Smaller font in menu */,
                                                                                },
                                                                            },
                                                                        }}
                                                                    >
                                                                        {getLanguagesForEditView()?.map((lang) => (
                                                                            <MenuItem
                                                                                key={lang}
                                                                                value={lang}
                                                                                sx={{
                                                                                    fontSize:
                                                                                        '0.75rem' /* Smaller font for menu items */,
                                                                                    '&:hover': {
                                                                                        backgroundColor:
                                                                                            'rgba(255, 255, 255, 0.08)',
                                                                                    },
                                                                                }}
                                                                            >
                                                                                {lang}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Close button */}
                                                    <button
                                                        className="close-drawer"
                                                        onClick={handleDualColumnMenuClick}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        {sectionDropdown}
                                    </Grid>

                                    {/* Export Type dropdown - show conditionally */}
                                    <Grid item sx={{ alignSelf: 'center', display: { xs: 'none', sm: 'block' } }}>
                                        <Tooltip title="Export Subtitles">
                                            <FormControl
                                                sx={{
                                                    width: '120px',
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: '#252526',
                                                        color: '#cccccc',
                                                        height: '35px',
                                                    },
                                                }}
                                                size="small"
                                            >
                                                <Select
                                                    id="exportTypeDropdown"
                                                    value={exportValue}
                                                    onChange={(e) => {
                                                        setExportValue(e.target.value);
                                                    }}
                                                >
                                                    <MenuItem value="SRT">Export SRT</MenuItem>
                                                    <MenuItem value="VTT">Export VTT</MenuItem>
                                                    <MenuItem value="ASS">Export ASS</MenuItem>
                                                    <MenuItem value="TXT">Export TXT</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Tooltip>
                                    </Grid>

                                    {/* Export button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Export">
                                            <Button
                                                id="exportButton"
                                                variant="vsCodeBlue"
                                                sx={{
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '100px' },
                                                }}
                                                onClick={(e) => {
                                                    if (exportValue === 'SRT') {
                                                        downloadSub('srt');
                                                    } else if (exportValue === 'VTT') {
                                                        downloadSub('vtt');
                                                    } else if (exportValue === 'ASS') {
                                                        downloadSub('ass');
                                                    } else if (exportValue === 'TXT') {
                                                        downloadSub('txt');
                                                    }
                                                }}
                                            >
                                                <FileDownloadIcon fontSize="small" />
                                                <Box
                                                    component="span"
                                                    sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}
                                                >
                                                    Export
                                                </Box>
                                            </Button>
                                        </Tooltip>
                                    </Grid>

                                    {/* Import button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Import SRT">
                                            <Button
                                                id="importButton"
                                                variant="vsCodeBlue"
                                                component="label"
                                                sx={{
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '110px' },
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                <FileUploadIcon fontSize="small" />
                                                <Box
                                                    component="span"
                                                    sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}
                                                >
                                                    Import SRT
                                                </Box>
                                                <input
                                                    className="file"
                                                    type="file"
                                                    hidden
                                                    onChange={onSubtitleChange}
                                                    onClick={onInputClick}
                                                />
                                            </Button>
                                        </Tooltip>
                                    </Grid>

                                    {/* Undo button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Undo">
                                            <Button
                                                id="undoButton"
                                                variant="vsCodeBlue"
                                                sx={{
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '100px' },
                                                }}
                                                onClick={undoSubs}
                                            >
                                                <ReplayIcon fontSize="small" />
                                                <Box
                                                    component="span"
                                                    sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}
                                                >
                                                    Undo
                                                </Box>
                                            </Button>
                                        </Tooltip>
                                    </Grid>

                                    {/* Save button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
                                        {(() => {
                                            const user = JSON.parse(localStorage.getItem('authUser'));
                                            const accessLevel = user?.languageAccess?.[selectedLng] || 'READ';
                                            const hasWriteAccess = accessLevel === 'WRITE' || accessLevel === 'ADMIN';

                                            return (
                                                <Tooltip
                                                    title={
                                                        !hasWriteAccess
                                                            ? 'You are in read-only mode'
                                                            : lastSaveTime
                                                            ? isSaving
                                                                ? 'Saving...'
                                                                : `Last saved: ${new Date(
                                                                      lastSaveTime,
                                                                  ).toLocaleTimeString()}`
                                                            : 'Save changes'
                                                    }
                                                >
                                                    <Button
                                                        id="saveButton"
                                                        variant="vsCodeBlue"
                                                        sx={{
                                                            height: '35px',
                                                            minWidth: { xs: '40px', lg: '100px' },
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '6px',
                                                        }}
                                                        onClick={(e) => {
                                                            // Existing onClick handler with hasWriteAccess check already there
                                                            if (!hasWriteAccess) {
                                                                Swal.fire({
                                                                    title: 'Read-Only Mode',
                                                                    text: 'You cannot save changes while in read-only mode.',
                                                                    icon: 'warning',
                                                                    confirmButtonText: 'OK',
                                                                });
                                                                return;
                                                            }

                                                            Swal.fire({
                                                                title: 'Do you want to save changes?',
                                                                showDenyButton: true,
                                                                showCancelButton: true,
                                                                confirmButtonText: 'Save',
                                                                denyButtonText: `Don't save`,
                                                            }).then(async (result) => {
                                                                const videoProps = JSON.parse(
                                                                    localStorage.getItem('videoProps'),
                                                                );

                                                                if (result.isConfirmed) {
                                                                    setLoading('Loading...');

                                                                    try {
                                                                        // Use the same autoSaveFunction for consistency
                                                                        console.log(
                                                                            'Manual save triggered for:',
                                                                            selectedLng,
                                                                        );
                                                                        const saveResult = await autoSaveFunction({});

                                                                        if (saveResult.success) {
                                                                            console.log(
                                                                                '✅ Manual save completed successfully',
                                                                            );
                                                                            Swal.fire({
                                                                                title: 'Success!',
                                                                                text: 'Your changes have been saved!',
                                                                                icon: 'success',
                                                                                confirmButtonText: 'Close',
                                                                            });
                                                                        } else {
                                                                            console.error(
                                                                                '❌ Manual save failed:',
                                                                                saveResult.message,
                                                                            );
                                                                            Swal.fire({
                                                                                title: 'Error!',
                                                                                text:
                                                                                    saveResult.message ||
                                                                                    'Failed to save changes',
                                                                                icon: 'error',
                                                                                confirmButtonText: 'Close',
                                                                            });
                                                                        }
                                                                    } catch (error) {
                                                                        console.error('❌ Manual save error:', error);
                                                                        Swal.fire({
                                                                            title: 'Error!',
                                                                            text:
                                                                                'Failed to save changes: ' +
                                                                                error.message,
                                                                            icon: 'error',
                                                                            confirmButtonText: 'Close',
                                                                        });
                                                                    } finally {
                                                                        setLoading('');
                                                                    }
                                                                } else if (result.isDenied) {
                                                                    addLog(
                                                                        'User Denied Saving of Video = ' +
                                                                            videoProps.id +
                                                                            ' VideoName = ' +
                                                                            videoProps.videoName +
                                                                            ' Language = ' +
                                                                            selectedLng,
                                                                    );
                                                                    Swal.fire('Changes are not saved', '', 'info');
                                                                }
                                                            });
                                                        }}
                                                    >
                                                        {isSaving ? (
                                                            <>
                                                                <CircularProgress
                                                                    size={16}
                                                                    color="inherit"
                                                                    sx={{ mr: 0.5 }}
                                                                />
                                                                <Box
                                                                    component="span"
                                                                    sx={{
                                                                        display: { xs: 'none', lg: 'inline' },
                                                                        ml: 0.5,
                                                                    }}
                                                                >
                                                                    Saving
                                                                </Box>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {!hasWriteAccess ? (
                                                                    <LockIcon
                                                                        fontSize="small"
                                                                        sx={{ color: '#ff5252' }}
                                                                    />
                                                                ) : (
                                                                    <SaveIcon fontSize="small" />
                                                                )}
                                                                <Box
                                                                    component="span"
                                                                    sx={{
                                                                        display: { xs: 'none', lg: 'inline' },
                                                                        ml: 0.5,
                                                                    }}
                                                                >
                                                                    Save
                                                                </Box>
                                                                {!hasWriteAccess ? (
                                                                    <Box
                                                                        sx={{
                                                                            ml: 0.5,
                                                                            width: '6px',
                                                                            height: '6px',
                                                                            borderRadius: '50%',
                                                                            backgroundColor: '#ff5252', // Red for read-only
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    lastSaveTime && (
                                                                        <Box
                                                                            sx={{
                                                                                ml: 0.5,
                                                                                width: '6px',
                                                                                height: '6px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: 'green', // Green for writable with last save
                                                                            }}
                                                                        />
                                                                    )
                                                                )}
                                                            </>
                                                        )}
                                                    </Button>
                                                </Tooltip>
                                            );
                                        })()}
                                    </Grid>

                                    {/* Bug report button - responsive text */}
                                    <Grid item sx={{ alignSelf: 'center' }}>
                                        <Tooltip title="Report a bug with this video">
                                            <Button
                                                id="reportBugButton"
                                                variant="vsCodeBlue"
                                                sx={{
                                                    height: '35px',
                                                    minWidth: { xs: '40px', lg: '110px' },
                                                    whiteSpace: 'nowrap',
                                                }}
                                                onClick={openBugReportWithCurrentVideo}
                                            >
                                                <BugReportIcon fontSize="small" />
                                                <Box
                                                    component="span"
                                                    sx={{ display: { xs: 'none', lg: 'inline' }, ml: 0.5 }}
                                                >
                                                    Report Bug
                                                </Box>
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                </Grid>
                            </Box>
                        </div>
                    </div>
                </div>
            </div>
        </Style>
    );
}
